import "./index.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./screens/Home";
import Duel from "./screens/Duel";
import Memory from "./screens/Memory";
import Flash from "./screens/Flash";
import Fastest from "./screens/Fastest";
import Signup from "./screens/Signup";
import Signin from "./screens/Signin";

export function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/signup" replace />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/home" element={<Home />} />
        <Route path="/duel" element={<Duel />} />
        <Route path="/memory" element={<Memory />} />
        <Route path="/flash" element={<Flash />} />
        <Route path="/fastest" element={<Fastest />} />
      </Routes>
    </>
  );
}

export default App;
